// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-center-solid';

export const Component = () => (
  <path d='M24.044 11.813c.335 0 .479.143.479.478 0 .336-.144.48-.48.48h-3.448v4.453c0 .431-.143.767-.43 1.006a1.408 1.408 0 0 1-1.055.43h-3.927c-.431 0-.767-.143-1.006-.43-.287-.24-.43-.575-.43-1.006V12.77h-2.97v7.376c0 .431-.144.767-.383 1.054a1.408 1.408 0 0 1-1.054.431H5.412c-.43 0-.766-.143-1.053-.431a1.408 1.408 0 0 1-.432-1.054V12.77H.48c-.335 0-.479-.143-.479-.479 0-.335.144-.479.479-.479h3.448V4.438c0-.432.144-.767.432-1.054A1.58 1.58 0 0 1 5.412 3H9.34c.431 0 .766.144 1.054.383.239.287.383.622.383 1.054v7.375h2.97V7.407c0-.431.143-.766.43-1.054.24-.287.575-.43 1.006-.43h3.927c.431 0 .767.143 1.054.43.288.288.431.623.431 1.054v4.407h3.449Z' />
);

export const viewBox = '0 0 25 25';
